import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const PhotoflipperFormViewAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "photoflipper-form-view" */ './photoflipper-form-view'),
  componentName: 'PhotoflipperFormView',
});
